<div id="event-online" fxFlex="row" fxLayoutAlign="center" fxLayoutGap="5px">
    <div class="blob red"></div>
    <p class="event-text" fxShow.gt-xs fxHide>{{ "EVENT_ONLINE" | translate }}</p>
</div>
